const styles = theme => ({
  notificationsContainer: {
    padding: theme.spacing(2)
  },
  titles: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/SideBox/components/Notifications/styles.js